interface FilterPillProps {
  label: string
  theme?: "orange" | "blue" | "gray"
  onRemove?: () => void
  /** Additional classes on the wrapper */
  className?: string
}

const THEME_CLASSES = {
  orange: "bg-[#ff9951]/10 text-[#ff9951]",
  blue: "bg-[#0469f0]/10 text-[#0469f0]",
  gray: "bg-gray-200 text-gray-700",
}

export function FilterPill({ label, theme = "orange", onRemove, className = "" }: FilterPillProps) {
  return (
    <span
      className={`px-3 py-1 rounded-full text-xs font-medium inline-flex items-center gap-1.5 ${THEME_CLASSES[theme]} ${className}`}
    >
      {label}
      {onRemove && (
        <button
          onClick={onRemove}
          className="hover:opacity-70 transition-opacity"
          aria-label={`Remove ${label} filter`}
        >
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </span>
  )
}
